var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "Icn/Lock");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0.046850819 23.5677912 0.046850819 23.5677912 26.9036612 0 26.9036612"
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Icn/Lock",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lock"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3828669,18.1127172 C17.9501296,18.0738582 17.5966269,17.9252406 17.3222135,17.6670112 C17.0470731,17.4098816 16.9097573,17.0635228 16.9097573,16.6271284 L16.9097573,8.12894703 C16.8702127,6.66374082 16.36929,5.44547289 15.4074254,4.47421655 C14.4444704,3.50384004 13.236615,3.01824853 11.7837865,3.01824853 C10.3302312,3.01824853 9.11212615,3.50384004 8.13085269,4.47421655 C7.14856154,5.44547289 6.63753462,6.66374082 6.59886231,8.12894703 L6.59886231,13.0614071 C6.59886231,13.4978749 6.46074692,13.854425 6.18647885,14.1310575 C5.91126577,14.4087897 5.56786731,14.5472159 5.15548385,14.5472159 C4.74288231,14.5472159 4.39861154,14.4087897 4.12434346,14.1310575 C3.84913038,13.854425 3.71188731,13.4978749 3.71188731,13.0614071 L3.71188731,8.12894703 C3.79017692,5.83179052 4.58550346,3.91985185 6.098085,2.39430414 C7.60979423,0.869489612 9.50524615,0.0868096552 11.7837865,0.046850819 C14.0614546,0.0868096552 15.9569792,0.869489612 17.4695608,2.39430414 C18.9811973,3.91985185 19.7574058,5.83179052 19.7969504,8.12894703 L19.7969504,16.6271284 C19.7969504,17.0635228 19.6587623,17.4098816 19.3844942,17.6670112 C19.1092085,17.9252406 18.7749692,18.0738582 18.3828669,18.1127172",
  id: "Fill-1",
  fill: "#ABADAB",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5629092,26.9080603 L2.94592846,26.9080603 C2.12108885,26.9080603 1.42317,26.6202101 0.854207308,26.0463425 C0.284445,25.4715219 0,24.7686129 0,23.9367359 L0,13.6556573 C0,12.8237803 0.284445,12.1207981 0.854207308,11.5461241 C1.42317,10.9722565 2.12108885,10.6842596 2.94592846,10.6842596 L20.5629092,10.6842596 C21.4264938,10.6842596 22.1333538,10.9722565 22.6839981,11.5461241 C23.2336246,12.1207981 23.5281738,12.8237803 23.5677912,13.6556573 L23.5677912,23.9367359 C23.5281738,24.7686129 23.2336246,25.4715219 22.6839981,26.0463425 C22.1333538,26.6202101 21.4264938,26.9080603 20.5629092,26.9080603",
  id: "Fill-3",
  fill: "#F4BD00",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.59235308,24.5309862 L2.41563808,24.5309862 C2.17989692,24.5309862 1.98297346,24.4418303 1.82639423,24.2635186 C1.66908808,24.0851335 1.59079846,23.8772009 1.59079846,23.6395742 L1.59079846,13.9528924 C1.59079846,13.715119 1.66908808,13.5071864 1.82639423,13.3288014 C1.98297346,13.1506363 2.17989692,13.0614071 2.41563808,13.0614071 L2.59235308,13.0614071 C2.82809423,13.0614071 3.02407269,13.1506363 3.18152423,13.3288014 C3.33810346,13.5071864 3.41733808,13.715119 3.41733808,13.9528924 L3.41733808,23.6395742 C3.41733808,23.8772009 3.33810346,24.0851335 3.18152423,24.2635186 C3.02407269,24.4418303 2.82809423,24.5309862 2.59235308,24.5309862",
  id: "Fill-5",
  fill: "#FACF6A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9537973,17.885795 C13.9537973,19.110955 12.9691073,20.104207 11.7544188,20.104207 C10.5397304,20.104207 9.55504038,19.110955 9.55504038,17.885795 C9.55504038,16.6606351 10.5397304,15.6674564 11.7544188,15.6674564 C12.9691073,15.6674564 13.9537973,16.6606351 13.9537973,17.885795",
  id: "Fill-6",
  fill: "#FACF6A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7644223,17.5690571 L10.7644223,21.4203557 C10.7644223,21.6779986 10.8492542,21.9033811 11.0198631,22.0967232 C11.1895269,22.2900653 11.4030242,22.3866997 11.6585377,22.3866997 L11.8500819,22.3866997 C12.1055954,22.3866997 12.318075,22.2900653 12.4889019,22.0967232 C12.6585658,21.9033811 12.7444154,21.6779986 12.7444154,21.4203557 L12.7444154,17.5622384 C12.0842238,17.528585 11.4241777,17.513408 10.7644223,17.5690571",
  id: "Fill-7",
  fill: "#FACF6A"
})));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lock.605352f3.svg";
export { ForwardRef as ReactComponent };